import { Box, Button, Divider, Flex, Group, Paper, Stack } from '@mantine/core';
import { tKeys, useTranslate } from 'locales/index';
import { type ReactNode, useState } from 'react';

type ReminderWizardShellProps = {
  step1: ReactNode;
  step2: ReactNode;
  preview: ReactNode;
  onCancel: () => void;
  onSend: () => void;
  canContinue: boolean;
  canSend: boolean;
  isSending?: boolean;
};

export const ReminderWizardShell = ({
  step1,
  step2,
  preview,
  onCancel,
  onSend,
  canContinue,
  canSend,
  isSending = false,
}: ReminderWizardShellProps) => {
  const t = useTranslate();
  const [isFirstStep, setIsFirstStep] = useState(true);

  return (
    <Stack gap="md">
      <Flex gap="lg" align="flex-start">
        <Box
          style={{
            flex: 5,
            height: '60vh',
            display: 'flex',
            flexDirection: 'column',
            minHeight: 0,
          }}
          pr="xs"
        >
          {isFirstStep ? step1 : step2}
        </Box>
        <Paper withBorder radius="md" p="sm" bg="var(--mantine-color-gray-0)" style={{ flex: 6 }}>
          {preview}
        </Paper>
      </Flex>

      <Divider />

      <Group justify="space-between">
        {isFirstStep ? (
          <Button variant="default" onClick={onCancel}>
            {t(tKeys.CANCEL)}
          </Button>
        ) : (
          <Button variant="default" onClick={() => setIsFirstStep(true)}>
            {t(tKeys.BACK)}
          </Button>
        )}

        {isFirstStep ? (
          <Button onClick={() => setIsFirstStep(false)} disabled={!canContinue}>
            {t(tKeys.CONTINUE)}
          </Button>
        ) : (
          <Button onClick={onSend} disabled={!canSend} loading={isSending}>
            {t(tKeys.AML_MODAL.ACTIONS.SEND)}
          </Button>
        )}
      </Group>
    </Stack>
  );
};
